import InlineColor from "../../../../src/components/InlineColor.jsx";
import * as React from 'react';
export default {
  InlineColor,
  React
};